import { createTheme } from '@mui/material/styles';
import Colors from './color';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: Colors.daintree,
    },
    secondary: {
      main: Colors.amber,
    },
    error: {
      main: Colors.torchRed,
      dark: Colors.redRibbon,
    },
    success: {
      main: Colors.abbey,
    },
  },
  typography: {
    fontFamily: ["'Prompt'", 'Helvetica', 'Arial', 'sans-serif'].join(','),
  },
});

export default theme;
